module.exports = __webpack_public_path__ + "static/media/balance-scale-left.22e0897c.svg";